// ========== 任务系统 v1.0 ==========
export const QUESTS = {
  // === 主线 ===
  q_main_first_step: {
    id:'q_main_first_step', name:'冒险的第一步', type:'main', icon:'⚔️', chapter:'序幕',
    desc:'击败幽暗密林深处的哥布林头目，证明你的实力。',
    objective:{ type:'kill_boss', target:'goblin_chief', count:1 },
    rewards:{ gold:300, exp:200, items:[{id:'hp_potion_m',qty:3}] },
    nextQuest:'q_main_forest_master',
  },
  q_main_forest_master: {
    id:'q_main_forest_master', name:'森林之主', type:'main', icon:'🌲', chapter:'格兰之森',
    desc:'通关格兰之森的最终试炼——暗黑雷鸣废墟。',
    objective:{ type:'clear_dungeon', target:'gf_dark_thunder', count:1 },
    rewards:{ gold:800, exp:500, items:[{id:'hp_potion_l',qty:2}], statBonus:{atk:2,def:1} },
    reqQuest:'q_main_first_step', nextQuest:'q_main_underground',
  },
  q_main_underground: {
    id:'q_main_underground', name:'地下城的阴影', type:'main', icon:'🏰', chapter:'赫顿玛尔',
    desc:'调查赫顿玛尔地下的罗兰河地下城，找出诅咒的源头。',
    objective:{ type:'clear_dungeon', target:'ht_dungeon', count:1 },
    rewards:{ gold:1000, exp:600, items:[{id:'mp_potion_s',qty:3}] },
    reqQuest:'q_main_forest_master', nextQuest:'q_main_ice_witch',
  },
  q_main_ice_witch: {
    id:'q_main_ice_witch', name:'寒冰的支配者', type:'main', icon:'❄️', chapter:'赫顿玛尔',
    desc:'击败冰封女巫冒昧图斯——冰龙的气息正在蔓延。',
    objective:{ type:'clear_dungeon', target:'ht_magic', count:1 },
    rewards:{ gold:1500, exp:800, items:[{id:'hp_potion_l',qty:2},{id:'mp_potion_s',qty:2}], statBonus:{def:2} },
    reqQuest:'q_main_underground', nextQuest:'q_main_dark_city',
  },
  q_main_dark_city: {
    id:'q_main_dark_city', name:'暗精灵的领地', type:'main', icon:'🕯️', chapter:'暗黑城',
    desc:'深入暗黑城要塞，击败暗影领主，揭开诺伊佩拉瘟疫的真相。',
    objective:{ type:'clear_dungeon', target:'dc_citadel', count:1 },
    rewards:{ gold:2000, exp:1000, statBonus:{atk:3,def:3} },
    reqQuest:'q_main_ice_witch', nextQuest:'q_main_sky_gate',
  },
  q_main_sky_gate: {
    id:'q_main_sky_gate', name:'天空之城的入口', type:'main', icon:'☁️', chapter:'天空之城',
    desc:'穿越龙人之塔，抵达天空之城神殿。巴卡尔的秘密正在等你。',
    objective:{ type:'clear_dungeon', target:'sky_temple', count:1 },
    rewards:{ gold:2500, exp:1200, items:[{id:'hp_potion_l',qty:3}] },
    reqQuest:'q_main_dark_city', nextQuest:'q_main_dragon_lair',
  },
  q_main_dragon_lair: {
    id:'q_main_dragon_lair', name:'龙王遗产', type:'main', icon:'🐉', chapter:'天空之城',
    desc:'击败天空龙王，获取巴卡尔的龙晶记忆——那是关于赫尔德阴谋的全部真相。',
    objective:{ type:'clear_dungeon', target:'sky_dragon_lair', count:1 },
    rewards:{ gold:4000, exp:2000, statBonus:{atk:5,def:5}, items:[{id:'chaos_crystal',qty:5}] },
    reqQuest:'q_main_sky_gate', nextQuest:'q_main_awaken',
  },
  q_main_awaken: {
    id:'q_main_awaken', name:'觉醒之路', type:'main', icon:'🌟', chapter:'觉醒',
    desc:'达到50级，完成你的第一次觉醒——释放你真正的力量。',
    objective:{ type:'reach_level', target:'50', count:1 },
    rewards:{ gold:5000, exp:3000, statBonus:{atk:8,def:5} },
    reqQuest:'q_main_dragon_lair',
  },

  // === 支线 ===
  q_side_goblin_slayer: {
    id:'q_side_goblin_slayer', name:'哥布林猎人', type:'side', icon:'🎯', chapter:'格兰之森',
    desc:'哥布林在森林中泛滥成灾。消灭20只哥布林以换取赏金。',
    objective:{ type:'kill_monster', target:'goblin', count:20 },
    rewards:{ gold:600, exp:300, items:[{id:'hp_potion_m',qty:5}] },
  },
  q_side_elite_hunter: {
    id:'q_side_elite_hunter', name:'精英猎手', type:'side', icon:'👹', chapter:'通用',
    desc:'击败5个精英怪物——它们在各自的领地中是最危险的捕食者。',
    objective:{ type:'kill_elite', target:'any', count:5 },
    rewards:{ gold:1000, items:[{id:'chaos_crystal',qty:3}] },
    reqLv:10,
  },
  q_side_boss_gauntlet: {
    id:'q_side_boss_gauntlet', name:'首领挑战', type:'side', icon:'💀', chapter:'通用',
    desc:'击败5个Boss——每个都是区域中最强的存在。',
    objective:{ type:'kill_boss', target:'any', count:5 },
    rewards:{ gold:2000, items:[{id:'chaos_crystal',qty:5}], statBonus:{atk:3} },
    reqLv:15,
  },
  q_side_gold_rush: {
    id:'q_side_gold_rush', name:'金币风暴', type:'side', icon:'💰', chapter:'通用',
    desc:'任何冒险家都需要资金。积攒10000金币。',
    objective:{ type:'collect_gold', target:'10000', count:1 },
    rewards:{ gold:1500, items:[{id:'hp_potion_l',qty:3}] },
  },
  q_side_dice_master: {
    id:'q_side_dice_master', name:'命运赌徒', type:'side', icon:'🎲', chapter:'通用',
    desc:'在地牢中成功掷出5次好运（掷骰≥4且成功）。命运眷顾勇者。',
    objective:{ type:'dice_win', target:'any', count:5 },
    rewards:{ gold:800, items:[{id:'chaos_crystal',qty:3}] },
    reqLv:5,
  },
  q_side_awaken_trial: {
    id:'q_side_awaken_trial', name:'觉醒试炼', type:'side', icon:'⚡', chapter:'觉醒',
    desc:'释放10次觉醒技能——只有反复锤炼才能真正掌握这股力量。',
    objective:{ type:'use_awaken', target:'any', count:10 },
    rewards:{ gold:3000, statBonus:{atk:5}, items:[{id:'chaos_crystal',qty:8}] },
    reqLv:50,
  },
  q_side_affix_collector: {
    id:'q_side_affix_collector', name:'词条收藏家', type:'side', icon:'📜', chapter:'通用',
    desc:'收集5件带词条的稀有及以上装备。诺顿会很高兴帮你鉴定。',
    objective:{ type:'collect_affix_gear', target:'5', count:1 },
    rewards:{ gold:1200, items:[{id:'chaos_crystal',qty:5}] },
    reqLv:8,
  },
  q_side_dungeon_delver: {
    id:'q_side_dungeon_delver', name:'地下城探索者', type:'side', icon:'🗺️', chapter:'通用',
    desc:'通关任意地下城10次。迷宫就是你的第二个家。',
    objective:{ type:'clear_dungeon', target:'any', count:10 },
    rewards:{ gold:1500, exp:800, items:[{id:'hp_potion_l',qty:5}] },
  },

  // === 每日 ===
  q_daily_boss_hunt: {
    id:'q_daily_boss_hunt', name:'[每日] Boss狩猎', type:'daily', icon:'💀', daily:true,
    desc:'今日击败任意3名Boss。',
    objective:{ type:'kill_boss', target:'any', count:3 },
    rewards:{ gold:500, exp:300, items:[{id:'chaos_crystal',qty:2}] },
  },
  q_daily_dungeon_clear: {
    id:'q_daily_dungeon_clear', name:'[每日] 副本通关', type:'daily', icon:'⚔️', daily:true,
    desc:'今日通关任意2个地下城。',
    objective:{ type:'clear_dungeon', target:'any', count:2 },
    rewards:{ gold:400, exp:200, items:[{id:'hp_potion_m',qty:3}] },
  },
  q_daily_monster_slayer: {
    id:'q_daily_monster_slayer', name:'[每日] 怪物清扫', type:'daily', icon:'👹', daily:true,
    desc:'今日击败任意20只怪物。',
    objective:{ type:'kill_monster', target:'any', count:20 },
    rewards:{ gold:300, exp:150, items:[{id:'hp_potion_s',qty:5}] },
  },
  q_daily_dice_gamble: {
    id:'q_daily_dice_gamble', name:'[每日] 命运之骰', type:'daily', icon:'🎲', daily:true,
    desc:'今日掷骰3次（任意结果）。好运歹运，都是修行。',
    objective:{ type:'dice_any', target:'any', count:3 },
    rewards:{ gold:350, items:[{id:'chaos_crystal',qty:1}] },
  },
  q_daily_gold_earn: {
    id:'q_daily_gold_earn', name:'[每日] 日进斗金', type:'daily', icon:'💰', daily:true,
    desc:'今日获得1000金币。',
    objective:{ type:'collect_gold_daily', target:'1000', count:1 },
    rewards:{ gold:200 },
  },
};
